import React from 'react'
import styled from 'styled-components'
import { SubMenu } from './SubMenu'

type Props = {
  className?: string
} & React.PropsWithChildren

export const Menu = styled((props: Props) => (
  <nav className={props.className}>{props.children}</nav>
))`
  background: #ffffff;
  width: 100%;
  line-height: 48px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: space-between;

  input[type='checkbox'] {
    display: none;
    &:checked {
      + {
        ${SubMenu} {
          display: flex;
        }
      }
    }
  }
  & > ul {
    list-style-type: none;
  }
  & ul > li {
    &:hover {
      > input[type='checkbox'] {
        + {
          ${SubMenu} {
            display: flex;
          }
        }
      }
    }
  }
`
